import gql from 'graphql-tag';

export const ProgramsAndRostersByOrganization = gql`
  query ProgramsAndRostersByOrganizationQuery($thirdPartyOrganizationId: String!) {
    EnterpriseProgramsV1Resource {
      byThirdPartyOrganizationId(thirdPartyOrganizationId: $thirdPartyOrganizationId, limit: 9999) {
        elements {
          id
          metadata {
            name
            slug
          }
          userRosters {
            elements {
              id
              contract {
                id
                name
                startsAt
                endsAt
                limitType
                contractState
                utilization {
                  id
                  total
                  remaining
                  totalEnrollment
                  totalUserLicense
                  remainingEnrollment
                  remainingUserLicense
                }
              }
              programInvitations(limit: 1) {
                paging {
                  total
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const ProgramsAndRostersByPrograms = gql`
  query ProgramsAndRostersByProgramsQuery($programIds: [String!]!) {
    EnterpriseProgramsV1Resource {
      multiGet(ids: $programIds) {
        elements {
          id
          metadata {
            name
            slug
          }
          userRosters {
            elements {
              id
              contract {
                id
                name
                startsAt
                endsAt
                limitType
                contractState
                utilization {
                  id
                  total
                  remaining
                  totalEnrollment
                  totalUserLicense
                  remainingEnrollment
                  remainingUserLicense
                }
              }
              programInvitations(limit: 1) {
                paging {
                  total
                }
              }
            }
          }
        }
      }
    }
  }
`;
